import { useMemo } from "react";
import { usePublishedUpdates, useMyUpdateViews } from "@/hooks/useAppUpdates";
import { useAuth } from "@/hooks/useAuth";

/**
 * Returns the count of published app_updates that the current user
 * has not yet seen (no entry in update_views).
 * Returns 0 while views are still loading to avoid false badge flashes.
 */
export function useUnseenUpdatesCount(): number {
  const { user } = useAuth();
  const { data: updates = [] } = usePublishedUpdates();
  const { data: views = [], isFetched: viewsFetched } = useMyUpdateViews();

  return useMemo(() => {
    if (!user || updates.length === 0 || !viewsFetched) return 0;
    const seenIds = new Set(views.map(v => v.update_id));
    return updates.filter(u => !seenIds.has(u.id)).length;
  }, [user, updates, views, viewsFetched]);
}
